import { styled } from '@/stitches.config';

import { ReactComponent as RightArrowIcon } from '@assets/icons/arrow-right.svg';
import { Box } from '@base-app';
import { CSSProperties } from '@stitches/react';

export const StyledRightArrowIcon = styled(RightArrowIcon, {});

export const StyledSubPageHeader = styled(Box, {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  variants: {
    isSticky: {
      true: {
        alignItems: 'center',
        backgroundColor: '$white',
        borderBottom: '$borderWidths$1 solid $grey200',
        boxShadow: '$stickyNav',
        display: 'flex',
        height: '$stickyNav$height',
        justifyContent: 'space-evenly',
        left: '0',
        margin: '0',
        overflow: 'visible',
        paddingLeft: '$studyInsights$sidebarWidthClose',
        position: 'fixed',
        transition: 'top 400ms ease-in-out 0s',
        width: '100%',
        zIndex: '$stickyHeader',
      },
    },
  },
});

export const StyledSubPageContainer = styled(Box, {
  display: 'flex',
  justifyContent: 'space-between',
  maxWidth: '$studyInsights$headerMaxWidth',
  width: '100%',
});

export const StyledLayoutOneContent = styled(Box, {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
});

export const StyledInfoPanel = styled(Box, {
  alignItems: 'flex-end',
  display: 'flex',
  gap: '$6',
  flexDirection: 'column',
  justifyContent: 'space-between',
});

export const StyledLoader: CSSProperties = {
  height: '520px',
  padding: '24px',
};
